export enum ServiceOptions {
  HomeRepair = 'Home Repair',
  Courier = 'Courier',
  DropOff = 'Drop off',
  ManualReferral = 'Manual Referral',
  SelfSend = 'Self Send',
  PayAndClaim = 'Pay and Claim',
}
